<div class="d-flex flex-column flex-auto">
  <span class="confirm-popup-title">{{'INFLUENCER.campaign.confirm_modal.title' | translate}}</span>
  <span class="confirm-popup-subtitle">{{'INFLUENCER.campaign.confirm_modal.subtitle' | translate}}</span>

  <div *ngFor="let error of channelErrors" class="d-flex form-error">
    <p class="error" role="alert" [innerHTML]="error.message | translate"></p>
  </div>

  <div class="social-account-list">
    <platform-field *ngFor="let channel of listChannel"
                    [channelData]="channel"
                    (modifyChannelResponse)="onModifyChannel($event)"
                    (authorizeClick)="authorizeChannel($event)"
                    (deleteClick)="onDeleteChannel($event)"
                    (handleChange)="onChangeHandle($event)">
    </platform-field>
  </div>
  <div class="social-list-activity">
    <div class="btn-add-channel" [ngClass]="{'disabled': numberOfAddedChannels >= maxChannelCanAdded}" >
      {{'INFLUENCER.labels.add_channel' | translate}}
      <achoo-filter-box
        [options]="platforms"
        [(model)]="selectedChannels"
        [makeSelectedItemOnTop]="false"
        [disabled]="numberOfAddedChannels >= maxChannelCanAdded"
        (selectEvent)="afterChangePlatform($event)"
        placement="bottom">
      </achoo-filter-box>
    </div>
    <span class="added-channel-info" [ngClass]="{'exceed-max': numberOfAddedChannels > maxChannelCanAdded}"
          *ngIf="numberOfAddedChannels > 0">
      {{'influencer_request.channels_left' | translate:{current_added: numberOfAddedChannels, total: maxChannelCanAdded} }}
    </span>
  </div>
  <div class="confirm-popup-btn">
    <button class="button blue confirm-btn" [disabled]="!isValidToSubmit" (click)="onConfirm()">
      {{'common.btn.accept' | translate}}
    </button>
  </div>
</div>
<achoo-popup #AlertRemoveSocial
             cancelBtnLabel="{{'common.btn.cancel' | translate}}"
             acceptBtnLabel="{{'common.btn.remove' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="acceptDeleteChannel()"
             (cancelCallback)="onCloseConfirmPopupBeforeDeletingChannel()">
  <div class="d-flex flex-column flex-auto">
    <span>{{'INFLUENCER.channel_remove_social' | translate}}</span>
  </div>
</achoo-popup>

<achoo-popup #AlertRemoveSocialMobile
             (cancelCallback)="closeDeleteChannelWarningPopup()">
  <div class="channel-auth-alert-dialog">
    <div class="dlg-body">
      <span>{{'INFLUENCER.channel_remove_social' | translate}}</span>
    </div>
    <div class="dlg-buttons d-flex justify-content-end align-items-center">
      <button (click)="acceptDeleteChannel()" type="button" class="button red">{{'common.btn.remove' | translate}}</button>
    </div>
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/campaign-acception-popup/campaign-acception-popup.component.html